import {
    convertPersianDateToUniversalDate,
    convertUniversalDateTimeToPersianDateTime, convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoCreatorInfo, RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoGridTwoColumn, RaikoLabel,
    RaikoMoneyInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined, RaikoToggleOutlined,
    showServerErrorMessage,
    showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {VowService} from "../../../serverService/vow/VowService";
import {css} from "@emotion/css";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import VowDetailGateway from "./VowDetailGateway";

export default function VowDetailBaseInfo() {

    const {id: vowId} = useParams()
    const service = new VowService();

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [price, setPrice] = useState(0)
    const [description, setDescription] = useState("")

    const [createdAt, setCreatedAt] = useState("")
    const [createdBy, setCreatedBy] = useState("")

    const [loadingInfo, setLoadingInfo] = useState(false)

    const [enabled, setEnabled] = useState(false)
    const [loadingEnabledState, setLoadingEnabledState] = useState(false)

    const [limitOfTotalAmount, setLimitOfTotalAmount] = useState(0)
    const [limitStatus, setLimitStatus] = useState(false)
    const [limitStatusLoading, setLimitStatusLoading] = useState(false)

    const [limitStartDate, setLimitStartDate] = useState("")
    const [limitEndDate, setLimitEndDate] = useState("")
    const [limitTimeEnabledStatus, setLimitTimeEnabledStatus] = useState(false)
    const [limitTimeLoadingState, setLimitTimeLoadingState] = useState(false)

    useEffect(() => {
        getBasicInfo();
        getEnabledStatus()
        getLimitOfTotalAmount()
        getLimitTimeInfo()
    }, []);

    function getBasicInfo() {
        loading.show()
        service.getBasicInfo(vowId)
            .then((response) => {
                setTitle(response.title)
                setSlug(response.slug)
                setPrice(response.amountPerUnit)
                setDescription(response.description)

                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }).catch((reason) => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateInfo() {
        setLoadingInfo(true)
        service.updateInformation(
            vowId,
            title,
            price,
            slug,
            description,
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoadingInfo(false)
        })
    }

    function getEnabledStatus() {
        setLoadingEnabledState(true)
        service.getVowEnabled(vowId)
            .then(response => {
                setEnabled(response.enabled)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoadingEnabledState(false)
        })
    }

    function handleUpdateEnabled() {
        setLoadingEnabledState(true)
        service.updateVowEnabled(vowId, enabled)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoadingEnabledState(false)
        })
    }

    function getLimitOfTotalAmount() {
        setLimitStatusLoading(true)
        service.getVowAmountLimit(vowId)
            .then(response => {
                setLimitOfTotalAmount(response.amountCeiling)
                setLimitStatus(response.amountLimit)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLimitStatusLoading(false)
        })
    }

    function handleUpdateLimitOfAmount() {
        setLimitStatusLoading(true)
        service.updateVoeAmountLimit(
            vowId,
            limitOfTotalAmount,
            limitStatus
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLimitStatusLoading(false)
        })
    }

    function getLimitTimeInfo() {
        setLimitTimeLoadingState(true)
        service.getVowTimeBaseInfo(vowId)
            .then(response => {
                setLimitStartDate(response.startDate ? convertUniversalDateToPersianDate(response.startDate) : "")
                setLimitEndDate(response.endDate ? convertUniversalDateToPersianDate(response.endDate) : "")
                setLimitTimeEnabledStatus(response.timeBase)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLimitTimeLoadingState(false)
        })
    }

    function handleUpdateLimitTime() {
        setLimitTimeLoadingState(true)
        service.updateVowTimeBase(
            vowId,
            limitStartDate && limitStartDate.length === 10 ? convertPersianDateToUniversalDate(limitStartDate) : null,
            limitEndDate && limitEndDate.length === 10 ? convertPersianDateToUniversalDate(limitEndDate) : null,
            limitTimeEnabledStatus
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLimitTimeLoadingState(false)
        })
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonLoadingState={loadingInfo}
                    actionButtonOnclickWithValidation={handleUpdateInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان"}
                                value={title}
                                setValue={setTitle}
                                required
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"SLUG"}
                                value={slug}
                                setValue={setSlug}
                                required
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"قیمت واحد(ریال)"}
                                value={price}
                                setValue={setPrice}
                                required
                            />
                        </RaikoGridThreeColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"توضیحات"}
                            value={description}
                            setValue={setDescription}
                            required
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <VowDetailGateway/>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"وضعیت انتشار"}
                    hasActionButton
                    actionButtonLoadingState={loadingEnabledState}
                    actionButtonOnclick={handleUpdateEnabled}
                    hasHelperButton
                    helperTitle={"راهنمای وضعیت انتشار"}
                    helperContent={<RaikoBaseDialogContentContainer>
                        <RaikoLabel
                            text={"* با فعالسازی این مورد نذر برای کاربران به نمایش درخواهد آمد و امکان پرداخت برای آن ها ایجاد خواهد شد."}/>
                    </RaikoBaseDialogContentContainer>}
                >
                    <RaikoToggleOutlined checked={enabled} setChecked={setEnabled} labelText={"منتشر شده / پیش نویس"}/>
                </RaikoSectionContainer>

            </RaikoBaseCardContainer>

            <RaikoGridTwoColumn>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"سقف مبلغ جمع آوری"}
                        hasActionButton
                        actionButtonLoadingState={limitStatusLoading}
                        actionButtonOnclickWithValidation={handleUpdateLimitOfAmount}
                        hasHelperButton
                        helperTitle={"راهنمای سقف مبلغ جمع آوری"}
                        helperContent={<RaikoBaseDialogContentContainer>
                            <RaikoLabel
                                text={"با فعالسازی این مورد پرداخت تا مبلغ وارد شده محدود خواهد شد."}/>
                            <RaikoLabel
                                text={"بعد از تامین مبلغ، نذر به طور خودکار غیرفعال خواهد شد."}/>
                        </RaikoBaseDialogContentContainer>}
                    >
                        <RaikoMoneyInputOutlined
                            labelText={"سقف مبلغ مورد نیاز"}
                            value={limitOfTotalAmount}
                            setValue={setLimitOfTotalAmount}
                            required
                        />
                        <RaikoToggleOutlined
                            checked={limitStatus}
                            setChecked={setLimitStatus}
                            labelText={"فعال / غیرفعال"}
                        />
                    </RaikoSectionContainer>

                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"محدودیت زمان"}
                        hasActionButton
                        actionButtonLoadingState={limitTimeLoadingState}
                        actionButtonOnclick={handleUpdateLimitTime}
                        hasHelperButton
                        helperTitle={"راهنمای محدودیت زمان"}
                        helperContent={<RaikoBaseDialogContentContainer>
                            <RaikoLabel
                                text={"با فعالسازی این مورد پرداخت در بازه ی زمانی وارد شده محدود خواهد شد و خارج از این بازه ی زمانی، نذر غیرفعال خواهد شد."}/>
                        </RaikoBaseDialogContentContainer>}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={limitStartDate}
                                setDate={setLimitStartDate}
                            />
                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={limitEndDate}
                                setDate={setLimitEndDate}
                            />
                        </RaikoGridTwoColumn>
                        <RaikoToggleOutlined
                            checked={limitTimeEnabledStatus}
                            setChecked={setLimitTimeEnabledStatus}
                            labelText={"فعال / غیرفعال"}
                        />
                    </RaikoSectionContainer>

                </RaikoBaseCardContainer>
            </RaikoGridTwoColumn>

            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>
    )
}